/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Format_Aria_LabelInputs */

const en_auto_format_aria_label = /** @type {(inputs: Auto_Format_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto format selected events`)
};

const fr_auto_format_aria_label = /** @type {(inputs: Auto_Format_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise en forme automatique des evenements selectionnes`)
};

const de_auto_format_aria_label = /** @type {(inputs: Auto_Format_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Ereignisse automatisch formatieren`)
};

const it_auto_format_aria_label = /** @type {(inputs: Auto_Format_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatta automaticamente gli eventi selezionati`)
};

const ru_auto_format_aria_label = /** @type {(inputs: Auto_Format_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое форматирование выбранных событий`)
};

const es_auto_format_aria_label = /** @type {(inputs: Auto_Format_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatear automáticamente los eventos seleccionados`)
};

const zh_cn2_auto_format_aria_label = /** @type {(inputs: Auto_Format_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动格式化选定事件`)
};

const ja_auto_format_aria_label = /** @type {(inputs: Auto_Format_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントを自動フォーマットする`)
};

const hi_auto_format_aria_label = /** @type {(inputs: Auto_Format_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित घटनाओं को स्वचालित रूप से स्वरूपित करें`)
};

const pt_pt2_auto_format_aria_label = /** @type {(inputs: Auto_Format_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatação automática dos eventos selecionados`)
};

/**
* | output |
* | --- |
* | "Auto format selected events" |
*
* @param {Auto_Format_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_format_aria_label = /** @type {((inputs?: Auto_Format_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Format_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_auto_format_aria_label(inputs)
	if (locale === "de") return de_auto_format_aria_label(inputs)
	if (locale === "it") return it_auto_format_aria_label(inputs)
	if (locale === "ru") return ru_auto_format_aria_label(inputs)
	if (locale === "es") return es_auto_format_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_auto_format_aria_label(inputs)
	if (locale === "ja") return ja_auto_format_aria_label(inputs)
	if (locale === "hi") return hi_auto_format_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_auto_format_aria_label(inputs)
	return en_auto_format_aria_label(inputs)
});